import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import Select from 'react-select';

const AdvancedSearchFormSelect = ({ input, label, options, placeholder, meta: { touched, error }, clang, disabled }) => {
    const handleInputChange = ({ value }) => {
       input.onChange(value);
    };

    return (
        <div className="advanced-search__field--select">
            <label className="advanced-search__field-label" htmlFor={input.name}>
                {label}
                {label && <span>:</span>}
            </label>
            <Select
                {...input}
                onChange={handleInputChange}
                value={input.value}
                className="advanced-search__input--select"
                clearable={false}
                placeholder={placeholder}
                deleteRemoves={false}
                disabled={disabled}
                backspaceRemoves={false}
                searchable={false}
                options={options}/>
            {touched && (error && <span className="advanced-search__field__error">{lang[clang].validation[error]}</span>)}
        </div>
    );
};

AdvancedSearchFormSelect.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(AdvancedSearchFormSelect);



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchFormSelect.js